import {AxiosError} from 'axios';
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import type {Member} from '../types';

type QueryParams = {
  q: string;
  groupId: number | string | undefined;
};

type Response = {
  meta: {current_page: number; last_page: number};
  data: Member[];
};

export function useMembersQuery({groupId, q}: QueryParams, options?: UseInfiniteQueryOptions<Response, AxiosError>) {
  return useInfiniteQuery<Response, AxiosError>(
    ['members', groupId, q],
    ({pageParam}) =>
      api
        .get<Response>(`v2/groups/${groupId}/members`, {
          params: {
            q,
            per_page: 10,
            page: pageParam,
            managers: 0,
          },
        })
        .then((res) => res.data),
    {
      enabled: !!groupId,
      ...options,
      getNextPageParam: ({meta}) => (meta.current_page < meta.last_page ? meta.current_page + 1 : undefined),
    },
  );
}
